import { Grid, Heading } from '@zappyrent/hundop';
import {
  I18nextContext,
  Trans,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import React, { useContext } from 'react';

import useUtmQueryString from '../../../hooks/useUtmQueryString';
import SequenceList from '../../UI/SequenceList';
import {
  StyledCtaButton,
  StyledCtaButtonWrapper,
  StyledGridWrapper,
  StyledImageBlock,
  StyledTextBlock,
  StyledTextWrapper,
  StyledBlocks,
} from './ReferALandlordHowTo.styles';
import ReferALandlordHowToImage from './ReferALandlordHowToImage';

const ReferALandlordHowTo = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation(['navigation', 'product']);
  const utmQueryString = useUtmQueryString('referral');

  const howToReferALandlordContent = {
    list: [
      {
        text: t('product:referALandlordHowTo1Description'),
        title: t('product:referALandlordHowTo1Title'),
      },
      {
        text: t('product:referALandlordHowTo2Description'),
        title: t('product:referALandlordHowTo2Title'),
      },
      {
        text: t('product:referALandlordHowTo3Description'),
        title: t('product:referALandlordHowTo3Title'),
      },
      {
        text: (
          <Trans
            components={{
              a: <a />,
            }}
            i18nKey="product:referALandlordHowTo4Description"
            t={t}
            values={{
              link: t('navigation:referralProgramTermsAndConditionsLink'),
            }}
          />
        ),
        title: t('product:referALandlordHowTo4Title'),
      },
    ],
  };

  return (
    <StyledBlocks>
      <StyledImageBlock>
        <ReferALandlordHowToImage />
      </StyledImageBlock>
      <StyledTextBlock>
        <StyledGridWrapper>
          <Grid container justifyContent="flex-end">
            <StyledTextWrapper>
              <Heading sm="24px" md="24px" lg="32px" tag="h2">
                {t('product:earningWithZappyrentIsSafeAndEasy')}
              </Heading>
              <SequenceList
                user="landlord"
                content={howToReferALandlordContent.list}
              />
              <StyledCtaButtonWrapper>
                <StyledCtaButton
                  href={`${process.env.GATSBY_REFERRAL_PROGRAM_URL}/${language}?${utmQueryString}`}
                  tag="a"
                  title={t('product:inviteALandlord')}
                  user="landlord"
                  width="100%"
                >
                  {t('product:inviteALandlord')}
                </StyledCtaButton>
              </StyledCtaButtonWrapper>
            </StyledTextWrapper>
          </Grid>
        </StyledGridWrapper>
      </StyledTextBlock>
    </StyledBlocks>
  );
};

export default ReferALandlordHowTo;
